var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDataAvailable)?_c('vue-apex-charts',{ref:"CSATAverageRating",staticClass:"custom-apex-chart",attrs:{"type":_vm.chartType,"height":_vm.chartHeight,"options":_vm.chartData.chartOptions,"series":_vm.chartData.series}}):_c('div',{staticClass:"no-data"},[_c('p',[_vm._v("Not enough data available")])])
}
var staticRenderFns = []

export { render, staticRenderFns }